// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_ed55d501"};